export default __webpack_public_path__ + "locales/vi/Errors.json?hash=7063d7bf1d60343c64f8c35f903847d6";